<template>
  <div class="bg-white rounded-lg m-3">
    <div class="border-b-0.5 flex justify-between items-center p-3">
      <p class="text-sm font-semibold">{{ title }}</p>
      <!-- <div class="h-6 w-6 bg-primary flex justify-center items-center rounded-md cursor-pointer"
        @click="() => handleClick(title)">
        <img class="h-full object-contain p-1.5" src="@/assets/icons/pencil.png" />
      </div> -->
    </div>

    <transition name="fade">
      <div
        v-if="get_error"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ get_error }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="edit_error"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ edit_error }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="delete_error"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ delete_error }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="create_error"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ create_error }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="create_success"
        class="p-1 text-center text-sm w-full bg-green-200"
      >
        {{ create_success }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="delete_success"
        class="p-1 text-center text-sm w-full bg-green-200"
      >
        {{ delete_success }}
      </div>
    </transition>

    <div class="py-3">
      <label for="" class="font-bold mb-2">Employee</label>
      <el-autocomplete
        class="bg-gray-200 rounded-full w-full border-none"
        v-model="selectedEmployee"
        :fetch-suggestions="fetchEmployees"
        @focus="fetchEmployees"
        :default-first-item="true"
        @select="getEmployeeId"
        placeholder="Enter employee name"
        value-key="Fullname"
      >
        <template slot-scope="{ item }">{{ item.Fullname }}</template>
      </el-autocomplete>
    </div>

    <div class="py-5">
      <label for="" class="font-bold mb-2">Benefits</label>
      <div
        v-if="employeeIdSelected"
        class="grid lg:grid-cols-4 justify-start gap-y-4 w-3/4 text-sm"
      >
        <div v-for="benefit in organizationBenefits" :key="benefit.Id">
          <input
            type="checkbox"
            :id="benefit.Name"
            class="text-gray-400 cursor-pointer"
            :value="benefit.Name"
            @change="(e) => assignEmployeeBenefits(e, benefit)"
            :checked="isAssigned(benefit.benefitId)"
          />
          <label :for="benefit.Name" class="mx-1 cursor-pointer">{{
            benefit.Name
          }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import Loader from "@/components/loader/loader.vue";

import axios from "axios";
export default {
  name: "benefitInfoCard",
  props: ["title", "data"],
  // components: { Loader },
  data() {
    return {
      selectedEmployee: null,
      tabTitle: null,
      edit_error: null,
      benefitTypes: null,
      create_success: null,
      create_error: null,
      get_error: null,
      benefitTypeInfo: null,
      benefitsAssigned: [],
      organizationBenefits: [],
      thisEmployeeBenefits: null,
      employeeIdSelected: null,
      employees: [],
      delete_error: null,
      delete_success: null,
      columns: [
        {
          field: "",
          key: "a",
          title: "#",
          width: 50,
          align: "left",

          operationColumn: true,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            row, column, h;
            return ++rowIndex;
          },
        },
        {
          field: "Name",
          key: "name",
          title: "benefit Workflow Name",
          align: "left",
          edit: true,

          renderBodyCell: ({ row, column, rowIndex }, h) => {
            rowIndex, h, row, column;

            return (
              <el-select
                size="small"
                value={row["Name"]}
                on-input={(val) => {
                  row["Name"] = val;
                  this.cellDataChange(row, column, val);
                }}
                placeholder=""
              >
                {this.benefitWorkflows.map((workflow) => (
                  <el-option value={workflow.Name}>{workflow.Name}</el-option>
                ))}
              </el-select>
            );
          },
        },
      ],
      // table data
      benefitWorkflows: [
        {
          Email: "",
          Sequence: null,
          Id: null,
        },
      ],
    };
  },

  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getTabTitle",
      "getCurrentEmployeeId",
    ]),
  },

  methods: {
    async fetchEmployees(queryString, callback) {
      if (queryString) {
        this.employeesToSelect = this.employees.filter((employee) =>
          employee?.Fullname.toLowerCase().includes(queryString?.toLowerCase())
        );
        if (queryString && !this.employeesToSelect.length) {
          callback([{ Fullname: "No results found" }]);
          return;
        }
        callback(this.employees);
      } else {
        callback(this.employees);
      }
    },
    isAssigned(benefitId) {
      //console.log(this.thisEmployeeBenefits.employeeBenefits)
      return this.thisEmployeeBenefits.employeeBenefits.filter(
        (benefit) => benefit.BenefitId === benefitId
      ).length >= 1
        ? true
        : false;
    },
    handleClick(title) {
      //console.log(title)
      this.$store.commit("setTabTitle", title);
      return this.showEditEmployee();
    },

    getEmployeeId(employee) {
      this.getEmployeeBenefitInfo(employee.Id);
      this.employeeIdSelected = employee.Id;
    },

    // /{organization}/setup/benefit/v1/request
    getBenefits() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/benefit/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode == 200) {
              this.get_success = response.data.StatusMessage;
              this.organizationBenefits = response.data.Data;
              //console.log(this.organizationBenefits)
              this.loading = false;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;

            setTimeout(() => {
              this.showEditError = false;
            }, 2000);
          }
        );
    },
    // /{organization}/employee/all/v1/request
    getEmployees() {
      // this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/all/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.employees = response.data.Data;
              //console.log(this.employees)
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    // /{organization}/employee/{employeeId}/compensation/benefit/v1/request
    getEmployeeBenefitInfo(EmployeeId) {
      // this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/${EmployeeId}/compensation/benefit/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.thisEmployeeBenefits = response.data.Data;
              //console.log(this.thisEmployeeBenefits)
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    // /{organization}/employee/benefit/type/v1/assign
    assignEmployeeBenefits(e, benefit) {
      //console.log(benefit)
      if (!e.target.checked) {
        this.deleteBenefitAssignedToEmployee(benefit.benefitId);
        return;
      }
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      const selectedBenefitId = this.organizationBenefits.find(
        (b) => b.benefitId === benefit.benefitId
      ).benefitId;
      const data = {
        EmployeeId: this.employeeIdSelected,
        BenefitId: selectedBenefitId,
      };

      //console.log(data)

      axios
        .post(
          `${this.getOrganization}/employee/benefit/${this.$ApiVersion}/assign`,
          data,
          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode == 200) {
              this.loading = false;
              this.create_success = response.data.StatusMessage;
              setTimeout(() => {
                this.create_success = null;
              }, 2500);
            } else {
              this.create_error = response.data.StatusMessage;
              this.loading = false;
              setTimeout(() => {
                this.create_error = null;
              }, 2500);
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },

    // /{organization}/employee/benefit/{assignedEmployeeBenefitId}/v1/unassign
    deleteBenefitAssignedToEmployee(benefitId) {
      //console.log(benefitId)
      const assignedEmployeeBenefitId =
        this.thisEmployeeBenefits.employeeBenefits.find(
          (benefit) => benefit.BenefitId == benefitId
        ).EmployeeBenefitsId;
      this.loading = true;
      axios
        .delete(
          `${this.getOrganization}/employee/benefit/${assignedEmployeeBenefitId}/${this.$ApiVersion}/unassign`,
          {
            headers: {
              Authorization: `Bearer ${this.getToken}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then(
          (response) => {
            if (response.data.StatusCode == 200) {
              this.loading = false;

              this.delete_success = response.data.StatusMessage;
              setTimeout(() => {
                this.delete_success = null;
              }, 2500);
            } else {
              this.loading = false;
              this.delete_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.delete_error = error.message;
            setTimeout(() => {
              this.delete_error = null;
            }, 2500);
          }
        );
    },
  },

  created() {
    this.getBenefits();
    this.tabTitle = this.getTabTitle.trim();
    this.getEmployees();
  },
};
</script>
